import { DisplayTime } from 'common/display-state/display-time.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { InlineWarningFactory } from 'common/warning/warning-inline-warnings-factory.js';
import { IModule } from 'redux-state/layout/types.js';
import { ILocationWarningType } from 'redux-state/weather-warnings/types.js';
import { LinkRef } from './condition/link-ref.js';

interface IForecast {
  header?: string;
  issuedAt?: string;
  warningLocation?: ILocationWarningType;
  text?: string[];
  icon?: IconNameV1;
}

interface IForecastOverviewSmall {
  forecasts: IForecast[];
}

interface IForecastItem {
  forecast: IForecast;
}

const Forecast = ({ forecast }: IForecastItem) => {
  const { header, issuedAt, warningLocation, text, icon } = forecast;

  const content = (
    <>
      <p className="u-mB-xs">{text}</p>
      {issuedAt && (
        <p className="fineprint u-textGrey u-mT-0 u-mB-0">
          Issued: <DisplayTime date={issuedAt} />
        </p>
      )}
    </>
  );

  return (
    <>
      {header && <p className="u-textBold">{header}</p>}
      {icon && <IconWithText icon={icon}>{content}</IconWithText>}
      {!icon && text && content}
      {warningLocation && <InlineWarningFactory location={warningLocation} />}
    </>
  );
};

export const ForecastOverviewSmall = ({
  config,
  isDrawer,
  modulePath,
}: IModule<IForecastOverviewSmall & IMapSlotClose>) => {
  const { forecasts, link } = config;

  return (
    <Tile dataModule="forecast-overview-small" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2
          isDrawer={isDrawer}
          modulePath={modulePath}
          config={config}
          onModuleClose={config.onModuleClose}
        />

        {forecasts.map((forecast, index) => (
          <Forecast forecast={forecast} key={index} />
        ))}

        <LinkRef link={link} />
      </div>
    </Tile>
  );
};
